import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Login from './pages/Login';
import Register from './pages/Register';
import CreateVaquita from './pages/CreateVaquita';
import MainPage from './pages/MainPage';
import ViewUsers from './pages/ViewUsers';
import MyVaquitas from './pages/MyVaquitas';
import VaquitaDetails from './pages/VaquitaDetails';
import VaquitaPreview from './pages/VaquitaPreview';
import Profile from './pages/Profile';
import Friends from './pages/Friends';
import UserProfilePage from './pages/UserProfilePage';
import NotificationsPage from './pages/NotificationsPage';
import AdminPanel from './pages/AdminPanel';
import Header from './components/Header';
import BottomNav from './components/BottomNav';
import RequireAuth from './components/RequireAuth';
import { useBackButton } from './hooks/useBackButton';
import './styles/theme.css';

function AppInner() {
  useBackButton();
  return (
    <div className="app">
      <Routes>
        <Route path="/" element={<Login />} />
        <Route path="/register" element={<Register />} />
        <Route path="*" element={
          <>
            <Header />
            <div className="content">
              <Routes>
                <Route path="/home" element={<RequireAuth><MainPage /></RequireAuth>} />
                <Route path="/create-vaquita" element={<RequireAuth><CreateVaquita /></RequireAuth>} />
                <Route path="/view-users" element={<RequireAuth><ViewUsers /></RequireAuth>} />
                <Route path="/my-vaquitas" element={<RequireAuth><MyVaquitas /></RequireAuth>} />
                <Route path="/vaquita/code/:inviteCode" element={<RequireAuth><VaquitaDetails /></RequireAuth>} />
                <Route path="/vaquita/preview/:inviteCode" element={<VaquitaPreview />} />
                <Route path="/profile" element={<RequireAuth><Profile /></RequireAuth>} />
                <Route path="/friends" element={<RequireAuth><Friends /></RequireAuth>} />
                <Route path="/user/:id" element={<RequireAuth><UserProfilePage /></RequireAuth>} />
                <Route path="/u/:encoded" element={<RequireAuth><UserProfilePage byEncoded /></RequireAuth>} />
                <Route path="/notifications" element={<RequireAuth><NotificationsPage /></RequireAuth>} />
                <Route path="/admin" element={<RequireAuth><AdminPanel /></RequireAuth>} />
              </Routes>
            </div>
            <BottomNav />
          </>
        } />
      </Routes>

      <style jsx>{`
        .app {
          min-height: 100vh;
          background: var(--bg-primary);
        }

        .content {
          padding-top: 60px;
          padding-bottom: 64px; /* space for bottom nav on mobile */
        }

        @media (min-width: 769px) {
          .content {
            padding-bottom: 0;
          }
        }
      `}</style>
    </div>
  );
}

function App() {
  return (
    <BrowserRouter>
      <AppInner />
    </BrowserRouter>
  );
}

export default App;
